import VerticalOptionsMenuUI from './VerticalOptionsMenuUI.js';
import { getOSM } from '../OverworldAnimation.js';

export default class YesOrNoMenuUI extends VerticalOptionsMenuUI {
    constructor({ menu, position = { x: 240 - 64, y: 112 } } = {}) {
        const actualMenu = menu ?? getOSM().yesOrNoMenu;
        super({ menu: actualMenu, position });
    }
}
